import Blogs from "./Blogs";

export { Blogs };
